import React, { PropTypes, Component } from 'react';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import { InviteWizardStore, GroupStore } from 'stores';
import { InviteWizardActions, InviteActions, GroupActions } from 'actions';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import { Wizard, WizardStep } from 'components/Wizard';
import * as Icons from 'components/Material/SvgIcons';
import CourseSelector from 'components/CourseSelector';
import GroupSelector from 'components/GroupSelector';
import StudentSelector from 'components/StudentSelector';
import {
  RaisedButton,
  Paper,
  TextField,
  Tabs,
  Tab,
  Styles,
  DatePicker,
  DropDownMenu,
  FloatingActionButton,
  List,
  ListItem,
  ListDivider
} from 'material-ui';
import InviteeAdder from 'components/InviteeAdder';
import Tag from 'components/Tag';
import Overview from 'components/Widgets/Overview';
import { FormattedDate } from 'react-intl';
import * as MaterialColors from 'components/Material/Styles/Colors';
import Message from 'services/Message';

let { Colors } = MaterialColors;

let { Spacing } = Styles;

let styles = {
  header: {
    margin: Styles.Spacing.desktopGutterMini,
    fontSize: 18
  }
};

export default class InviteWizard extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  state = {
    newGroup: {}
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.accessTimes = {
      oneMonth: context.getIntlMessage('invite.oneMonth'),
      threeMonths: context.getIntlMessage('invite.threeMonths'),
      sixMonths: context.getIntlMessage('invite.sixMonths'),
      oneYear: context.getIntlMessage('invite.oneYear'),
      twoYears: context.getIntlMessage('invite.twoYears'),
    };
    this.menuItems = [
      { payload: null, text: context.getIntlMessage('invite.chooseAccessTime') }
    ];
    Object.keys(this.accessTimes).forEach(time => {
      this.menuItems.push({ payload: time, text: this.accessTimes[time] });
    });
  }

  listenToStores() {
    this.listenToStore(InviteWizardStore);
    this.listenToStore(GroupStore, 'groups');
  }

  selectCourses(courses) {
    InviteWizardActions.selectCourses(
      Object.keys(courses).map(x => courses[x])
    );
  }

  selectGroups(groups) {
    InviteWizardActions.selectGroups(Object.keys(groups).map(x => groups[x]));
    this.refs.inviteesAdder.reset();
    this.refs.studentSelector.reset();
    InviteWizardActions.selectStudents([]);
    InviteWizardActions.setInvitees([]);
  }

  selectStudents(students) {
    InviteWizardActions.selectStudents(
      Object.keys(students).map(x => students[x])
    );
    this.refs.inviteesAdder.reset();
    this.refs.groupSelector.reset();
    InviteWizardActions.selectGroups([]);
    InviteWizardActions.setInvitees([]);
  }

  addInvitees(invitees) {
    InviteWizardActions.setInvitees(invitees);
    this.refs.groupSelector.reset();
    this.refs.studentSelector.reset();
    InviteWizardActions.selectGroups([]);
    InviteWizardActions.selectStudents([]);
  }

  getCardStyle() {
    return {
      marginBottom: Spacing.desktopGutter,
      backgroundColor: this.context.muiTheme.rawTheme.palette.cardColor
    };
  }

  createCourseChoice(completed) {
    return (
      <WizardStep
        title={this.context.getIntlMessage('invite.chooseCourses')}
        icon={1}
        completed={completed}
      >
        <div style={styles.header}>
          {this.context.getIntlMessage('invite.chooseCourseExplanation')}
        </div>
        <CourseSelector
          ref="courseSelector"
          onSelect={this.selectCourses.bind(this)}
          selected={this.state.selectedCourses}
        />
      </WizardStep>
    );
  }

  createStudentChoice(completed) {
    return (
      <WizardStep
        title={this.context.getIntlMessage('invite.chooseStudents')}
        icon={2}
        completed={completed}
      >
        <div style={styles.header}>
          {this.context.getIntlMessage('invite.chooseStudentsOrGroups')}
        </div>
        <Tabs>
          <Tab label={this.context.getIntlMessage('invite.existingStudents')}>
            <StudentSelector
              ref="studentSelector"
              selected={this.state.selectedStudents}
              onSelect={this.selectStudents.bind(this)}
            />
          </Tab>
          <Tab label={this.context.getIntlMessage('invite.newStudents')}>
            <InviteeAdder
              initial={this.state.invitees}
              ref="inviteesAdder"
              onChange={this.addInvitees.bind(this)}
            />
          </Tab>
          <Tab label={this.context.getIntlMessage('invite.groups')}>
            <GroupSelector
              ref="groupSelector"
              selected={this.state.selectedGroups}
              onSelect={this.selectGroups.bind(this)}
            />
          </Tab>
        </Tabs>
      </WizardStep>
    );
  }

  setAccessTime(e, index, menuItem) {
    this.setState({ accessTime: menuItem.payload, endTime: null });
  }

  setEndTime(foo, date) {
    this.setState({ endTime: date.toISOString(), accessTime: null });
  }

  createAccessTime(completed, accessTime) {
    let step;
    let menuItems = this.menuItems;
    if (accessTime) {
      let selectedIndex = menuItems.findIndex(
        item => item.payload === this.state.accessTime
      );
      step = (
        <div>
          <h3>
            {this.context.getIntlMessage('invite.chooseAccessTimeExplanation')}
          </h3>
          <DropDownMenu
            selectedIndex={selectedIndex}
            menuItems={menuItems}
            onChange={this.setAccessTime.bind(this)}
          />
        </div>
      );
    } else {
      step = (
        <div>
          <h3>
            {this.context.getIntlMessage('invite.chooseEndDateExplanation')}
          </h3>
          <DatePicker
            minDate={new Date()}
            maxDate={this.state.endDate}
            hintText={this.context.getIntlMessage('invite.chooseEndDate')}
            defaultValue={this.state.endDate}
            onChange={this.setEndTime.bind(this)}
          />
        </div>
      );
    }
    return (
      <WizardStep
        title={this.context.getIntlMessage('invite.chooseAccessTime')}
        icon={3}
        completed={completed}
      >
        {step}
      </WizardStep>
    );
  }

  deleteTag(tagName) {
    let { tags } = this.state;
    delete tags[tagName];
    this.setState({ tags });
  }

  addTag() {
    let tagName = this.refs.addTag.getValue();
    let { tags } = this.state;
    tags[tagName] = true;
    this.setState({ tags });
    this.refs.addTag.clearValue();
  }

  /*createTagCreator() {
    let tags = [];
    if (this.state.tags) {
      tags = Object.keys(this.state.tags).map(tag => {
        if (this.state.tags[tag])
          return <Tag onDelete={this.deleteTag.bind(this)} key={tag} controls={true} mini={false} name={tag} />;
      });
    }
    return (
      <Paper style={this.getCardStyle()}>
        <Overview header={this.context.getIntlMessage('invite.createTags')}>
          <div style={{ padding: Spacing.desktopGutterMini * 2 }}>
            {tags}
            <div>
              <TextField fullWidth={true} floatingLabelText={this.context.getIntlMessage('tag.name')} hintText={'Type a new tag and press enter to add it to these students'} ref='addTag' onEnterKeyDown={this.addTag.bind(this)}/>
            </div>
          </div>
        </Overview>
      </Paper>
    );
  }*/

  onChange(e) {
    e.preventDefault();
    const grName = this.refs.groupName.getValue();
    if (grName.trim().length != 0) {
      GroupActions.create(this.refs.groupName.getValue());
      GroupActions.filter();
    } else {
      return;
    }
  }

  createSummary(completed) {
    let courses = this.state.selectedCourses,
      students = this.state.selectedStudents,
      groups = this.state.selectedGroups,
      invitees = this.state.invitees,
      accessTime = this.state.accessTime,
      endTime = this.state.endTime;
    //tagCreator = this.createTagCreator();
    let courseList, choiceList, accessElement;
    let courseElements = [],
      choiceElements = [];

    let groupCreator;
    courses.forEach((course, index) => {
      courseElements.push(
        <ListItem primaryText={course.name} key={'i-' + index} />
      );
      courseElements.push(<ListDivider key={'d-' + index} />);
    });

    if (endTime) {
      accessElement = (
        <Paper style={this.getCardStyle()}>
          <Overview header={this.context.getIntlMessage('invite.accessTime')}>
          <List>
            <ListItem primaryText={<div>{this.context.getIntlMessage('invite.willHaveAccessTill')} <strong><FormattedDate value={endTime} day="numeric" month="long" year="numeric" /></strong></div>} />
          </List>
          </Overview>
        </Paper>
      );

    } else {
      accessElement = (
        <Paper style={this.getCardStyle()}>
          <Overview header={this.context.getIntlMessage('invite.accessTime')}>
          <List>
            <ListItem primaryText={<div>{this.context.getIntlMessage('invite.willHaveAccessFor')} <strong>{this.accessTimes[accessTime]}</strong></div>} />
          </List>
          </Overview>
        </Paper>
      );

    }
    courseList = (
      <Overview header={this.context.getIntlMessage('invite.selectedCourses')}>
        <List>{courseElements}</List>
      </Overview>
    );

    if (students.length > 0 || invitees.length > 0) {
      if (students.length > 0) {
        students.forEach((student, index) => {
          choiceElements.push(
            <ListItem primaryText={student.name} key={'i-' + index} />
          );
          choiceElements.push(<ListDivider key={'d-' + index} />);
        });
        choiceList = (
          <Overview
            header={this.context.getIntlMessage('invite.selectedStudents')}
          >
            <List>{choiceElements}</List>
          </Overview>
        );
      } else if (invitees.length > 0) {
        invitees.forEach((email, index) => {
          choiceElements.push(
            <ListItem primaryText={email} key={'i-' + index} />
          );
          choiceElements.push(<ListDivider key={'d-' + index} />);
        });
        choiceList = (
          <Overview header={this.context.getIntlMessage('invite.newStudents')}>
            <List subheader="">{choiceElements}</List>
          </Overview>
        );
      }
      groupCreator = (
        <Paper style={this.getCardStyle()}>
          <Overview header={this.context.getIntlMessage('invite.addToGroup')}>
            <div style={{ padding: Spacing.desktopGutterMini }}>
              <TextField
                fullWidth={true}
                floatingLabelText={this.context.getIntlMessage('group.name')}
                hintText={this.context.getIntlMessage(
                  'invite.createGroupExplanation'
                )}
                ref="groupName"
                onEnterKeyDown={this.onChange.bind(this)}
              />
            </div>
          </Overview>
        </Paper>
      );
    } else if (groups.length > 0) {
      groups.forEach((group, index) => {
        choiceElements.push(
          <ListItem primaryText={group.name} key={'i-' + group.is} />
        );
        choiceElements.push(<ListDivider key={'d-' + group.id} />);
      });
      choiceList = (
        <Overview header={this.context.getIntlMessage('invite.selectedGroups')}>
          <List>{choiceElements}</List>
        </Overview>
      );
    }

    return (
      <WizardStep
        title={this.context.getIntlMessage('invite.summary')}
        icon={4}
        completed={completed}
      >
        <h3>{this.context.getIntlMessage('invite.summaryExplanation')}</h3>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ flexGrow: 1, padding: Spacing.desktopGutterMini }}>
            <Paper style={this.getCardStyle()}>{courseList}</Paper>
          </div>
          <div style={{ flexGrow: 1, padding: Spacing.desktopGutterMini }}>
            <Paper style={this.getCardStyle()}>{choiceList}</Paper>
          </div>
        </div>
        <div style={{ padding: Spacing.desktopGutterMini }}>
          {accessElement}
        </div>
        <RaisedButton
          style={{ marginBottom: Spacing.desktopGutterMore }}
          onTouchTap={::this.finalize}
          secondary={true}
          label={this.context.getIntlMessage('invite.confirmSend')}
          fullWidth={true}
        />
      </WizardStep>
    );
  }

  finalize() {
    let courseIds = this.state.selectedCourses.map(course => course.id);
    let circleIds = this.state.selectedGroups.map(group => group.id);
    let userIds = this.state.selectedStudents.map(student => student.id);
    let selected = this.state.groups.selected;
    let studentChosen = this.state.selectedStudents.map(
      student => student.email
    );

    let { accessTime, endTime } = this.state;
    let invitees = this.state.invitees;

    if (invitees.length > 0) {
      InviteActions.inviteByEmails(invitees, courseIds, accessTime, () => {
        Message.info(this.context.getIntlMessage('invite.sentOut'));
        this.reset();
      });
    }
    if (circleIds.length > 0) {
      InviteActions.inviteByCircleIds(circleIds, courseIds, endTime, () => {
        Message.info(this.context.getIntlMessage('invite.sentOut'));
        this.reset();
      });
    }
    if (userIds.length > 0) {
      InviteActions.inviteByUserIds(userIds, courseIds, accessTime, () => {
        Message.info(this.context.getIntlMessage('invite.sentOut'));
        this.reset();
      });
    }

    //this one should be called for adding students to a group but it does not work because it contradicts with
    //inviting students to a course
    /* if (selected && selected.id) {
      InviteActions.inviteByEmails(studentChosen, selected.id, accessTime, () => {
        Message.info(this.context.getIntlMessage('invite.sentOut'));
        this.reset();
      })
    } */
  }

  reset() {
    InviteWizardActions.reset();
  }

  restart() {
    InviteWizardActions.restart();
  }

  getFloatingActionButtonStyle(hasDetail) {
    let style,
      componentTheme = this.context.muiTheme;
    if (this.context.media === 'phone') {
      style = {
        zIndex: 10,
        position: 'fixed',
        right: Spacing.desktopGutter,
        bottom: Spacing.desktopGutter
      };
    } else {
      style = {
        zIndex: 10,
        position: 'fixed',
        right: Spacing.desktopKeylineIncrement,
        top:
          componentTheme.toolbar.height -
          componentTheme.floatingActionButton.buttonSize / 2
      };
    }
    return style;
  }

  render() {
    let courseChosen = Object.keys(this.state.selectedCourses).length > 0,
      studentChosen = Object.keys(this.state.selectedStudents).length > 0,
      groupChosen = Object.keys(this.state.selectedGroups).length > 0,
      inviteesAdded = this.state.invitees.length > 0,
      accessTime = this.state.accessTime,
      endTime = this.state.endTime,
      courseChoiceStep = this.createCourseChoice(courseChosen),
      studentChoiceStep = this.createStudentChoice(
        studentChosen || groupChosen || inviteesAdded
      ),
      accessTimeStep = this.createAccessTime(((studentChosen || inviteesAdded) && accessTime) || (groupChosen && endTime), studentChosen || inviteesAdded),
      summaryStep = this.createSummary();
    let floatingActionButton = (
      <FloatingActionButton style={this.getFloatingActionButtonStyle()}>
        <Icons.HardwareKeyboardArrowRight />
      </FloatingActionButton>
    );
    let sendButton = (
      <FloatingActionButton
        backgroundColor={Colors.green[500].material}
        style={this.getFloatingActionButtonStyle()}
      >
        <Icons.ActionDoneAll />
      </FloatingActionButton>
    );

    let wizard;

    if (this.state.step === 0) {
      wizard = (
        <div
          style={{
            margin: `${Spacing.desktopGutterMore}px auto`,
            width: Spacing.desktopKeylineIncrement * 12
          }}
        >
          <h3>{this.context.getIntlMessage('invite.success')}</h3>
          <RaisedButton
            fullWidth={true}
            secondary={true}
            label={this.context.getIntlMessage('invite.inviteMore')}
            onTouchTap={::this.restart}
          />
        </div>
      );
    } else {
      wizard = (
        <Wizard
          ref="wizard"
          onFinalize={::this.finalize}
          nextButton={floatingActionButton}
          finalButton={sendButton}
        >
          {courseChoiceStep}
          {studentChoiceStep}
          {accessTimeStep}

          {summaryStep}
        </Wizard>
      );
    }

    return (
      <AppPage
        header={<RulerBar title={this.context.getIntlMessage('Invite')} />}
      >
        {wizard}
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/InviteWizard.js